import React, { memo } from 'react'
import { Box } from '@mui/material'

import NftIcon from '../nft/NftIcon'
import { Image } from '../image'

const RedeemImage = ({ image, metadata, name, onClick, isNft = false }) => {
  const defaultImageProps = { borderRadius: 1.5, cursor: 'pointer' }
  const imageProps =
    isNft && !image
      ? {
          icon: <NftIcon metadata={metadata} />,
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...defaultImageProps
          }
        }
      : {
          sx: defaultImageProps
        }

  return (
    <Box sx={{ px: 1, pt: 1 }}>
      <Image
        alt={name}
        src={image}
        ratio='1/1'
        onClick={onClick}
        visibleByDefault={false}
        {...imageProps}
      />
    </Box>
  )
}

export default memo(RedeemImage)
